import React, { useState } from 'react'
import {
    Box,
    Stepper,
    Step,
    StepLabel,
    Button,
    Typography
} from '@mui/material';
import DetailTemplate from '../common/template/DetailTemplate';

import PartnerFormContainer from '../../containers/partnermng/PartnerFormContainer';
import PartnerAddGuideInfo from './PartnerAddGuideInfo';
const steps = [
    { value: 0, label: '기본정보', color: 'info' },
    { value: 1, label: '파일관리', color: 'primary' },
];

const PartnerStepperTemplate = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [message, setMessage] = useState(
        '기본사항 등록이 완료되지 못했습니다.',
    );
    const handleNext = () => {

    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <Box>
            <Box sx={{my:1}}>
                <PartnerAddGuideInfo/>
            </Box>
            <Box sx={{ width: '100%' }}>
                <Stepper sx={{
                    pt: 2,
                    pb: 1,
                    backgroundColor: '#eeeeee',
                }}
                    activeStep={activeStep}
                    alternativeLabel>
                    {steps.map((step) => {
                        const stepProps = {};
                        const labelProps = {};

                        if (activeStep === steps.length - 1) {
                            stepProps.completed = true;
                        }
                        return (
                            <Step key={step.label} {...stepProps}>
                                <StepLabel
                                    {...labelProps}
                                >{step.label}</StepLabel>
                            </Step>
                        )
                    })}
                </Stepper>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                    }}
                >
                    {activeStep === 0 && (
                        <DetailTemplate title="기본정보">
                            <PartnerFormContainer type="add"/>
                        </DetailTemplate>
                    )}
                    {activeStep === 1 && (
                        <DetailTemplate title="파일관리">
                            <Typography variant="body2">기본정보를 저장해야합니다.</Typography>
                        </DetailTemplate>
                    )}
                </Box>
            </Box>
        </Box>
    )
}


export default PartnerStepperTemplate